import GpParser from "../../gpParser";
import { CATEGORIES } from "../../configuration/constants";

import Button from "./Button";
import Switch from './Switch';
import RelativeLink from './RelativeLink';
import UploadFile from './UploadFile';
import Input from './Input';
import Select from './Select';
import MdcRadio from './MdcRadio';
import MdcRadioGroup from './MdcRadioGroup';
import MdcCheckbox from './MdcCheckbox';
import MdcCheckboxGroup from './MdcCheckboxGroup';
import JSlider from './JSlider'
import Rating from './Rating'
import RichText from './RichText'
// import CascadeAddress from './CascadeAddress'
import Geolocation from './Geolocation'
import Phone from './Phone'
import Modal from "./Modal";

export default (editor, opt = {}) => {
  GpParser.loadFromList(
    [
      Geolocation,
      Phone,
      // CascadeAddress,
      Switch,
      Modal,
      JSlider,
      Rating,
      RichText,
      Input,
      Select,
      MdcRadio,
      MdcRadioGroup,
      MdcCheckbox,
      MdcCheckboxGroup,
      RelativeLink,
      UploadFile,
      Button
    ],
    CATEGORIES.CONTROL,
    editor,
    opt
  );
};
